// extracted by mini-css-extract-plugin
var _1 = "NewsboardWelcomePostFooter-modulecontainer__D2QKg";
export { _1 as "container" }
